import { validatePhone } from './utils';
import { fetchPhone } from '../../repositories/phone/fetchPhone';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { TThunkAction } from '../../types/redux/thunk';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { trackPhoneFormFailed } from './tracking';
import { openOtpModal } from '../otpModal/actions';

export enum EPhoneActionTypes {
  ChangePhone = 'PHONE/ChangePhoneNumber',
  ConfirmPhoneRequest = 'PHONE/ConfirmPhoneRequest',
  ConfirmPhoneSuccess = 'PHONE/ConfirmPhoneSuccess',
  ConfirmPhoneError = 'PHONE/ConfirmPhoneError',
}

export const changePhone = actionGenerator<EPhoneActionTypes.ChangePhone, string>(EPhoneActionTypes.ChangePhone);

export const confirmPhoneRequest = actionGenerator<EPhoneActionTypes.ConfirmPhoneRequest>(
  EPhoneActionTypes.ConfirmPhoneRequest,
);
export const confirmPhoneSuccess = actionGenerator<EPhoneActionTypes.ConfirmPhoneSuccess, string>(
  EPhoneActionTypes.ConfirmPhoneSuccess,
);
export const confirmPhoneError = actionGenerator<EPhoneActionTypes.ConfirmPhoneError, string>(
  EPhoneActionTypes.ConfirmPhoneError,
);

export type TChangePhone = ITypedReduxAction<EPhoneActionTypes.ChangePhone, string>;
export type TConfirmPhoneRequest = ITypedReduxAction<EPhoneActionTypes.ConfirmPhoneRequest, void>;
export type TConfirmPhoneSuccess = ITypedReduxAction<EPhoneActionTypes.ConfirmPhoneSuccess, string>;
export type TConfirmPhoneError = ITypedReduxAction<EPhoneActionTypes.ConfirmPhoneError, string>;

export type TConfirmPhoneActions = TChangePhone | TConfirmPhoneRequest | TConfirmPhoneSuccess | TConfirmPhoneError;

export const confirmPhone = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const {
    trackLabel,
    phone: { phoneNumber },
  } = getState();

  if (!phoneNumber.trim()) {
    dispatch(confirmPhoneError('Введите номер телефона'));
    trackPhoneFormFailed(trackLabel);

    return;
  }

  if (!validatePhone(phoneNumber)) {
    dispatch(confirmPhoneError('Неправильно введен номер телефона'));
    trackPhoneFormFailed(trackLabel);

    return;
  }

  dispatch(confirmPhoneRequest());

  try {
    const res = await fetchPhone(context, { phone: phoneNumber });

    if (res.uuid) {
      dispatch(confirmPhoneSuccess(res.uuid));
      dispatch(openOtpModal());
    } else {
      dispatch(confirmPhoneError('Возникла ошибка во время отправки номера'));
    }
  } catch (error) {
    context.logger.error(error);

    dispatch(confirmPhoneError('Возникла ошибка во время отправки номера'));
  }
};
